import { Box, IconButton, Menu, MenuButton, MenuDivider, MenuItem, MenuList } from '@chakra-ui/react'
import { IoChevronDownOutline } from "react-icons/io5";
import { redirectToNewPage } from '../../global/helpers/global-helpers';
import useRoomTour from '../../global/hooks/room-product-tour';
import useLaunchdeckModal from '../../global/hooks/use-launchdeck-modal';


export default function DsrHeaderMoreOptionsButton({
  handleUnpublishRoom,
  setIsReadingMode,
  isReadingMode,
  dsrId,
  isDsrAdmin,
  isLockedRoom,
  lockedRoomMetadata,
  overviewPageId,
  firstCustomPageId,
  isArchivedDsr
}) {


  const { openLaunchdeckModal } = useLaunchdeckModal();

  const { startTour } = useRoomTour({
    overviewPageId,
    firstCustomPageId
  });

  function renderReadingModeOption() {
    return (
      <MenuItem name='copy-link-option' className='filter-menu__dropdown-option-display' onClick={() => setIsReadingMode(typeof isReadingMode === "boolean" ? !isReadingMode : true)}  >Reading Mode <span><Box fontSize='0.7em' fontWeight='600' color={isReadingMode ? 'brand.500' : 'gray.500'} ml='0.5em'>{isReadingMode ? "ON" : "OFF"}</Box></span></MenuItem>
    )
  }

  function renderRoomTourOption() {
    return (
      <MenuItem name='copy-link-option' className='filter-menu__dropdown-option-display' onClick={() => startTour()}  >Room tour
        {/* <span><Box fontSize='0.7em' fontWeight='600' color={isReadingMode ? 'brand.500' : 'gray.500'} ml='0.5em'>{isReadingMode ? "ON" : "OFF"}</Box></span> */}
      </MenuItem>
    )
  }

  function renderAdminOptions() {
    if (isLockedRoom) {
      const { lockerUserName } = lockedRoomMetadata || {};

      return (
        <MenuList p='0.875em 0.5em' fontSize='0.875em'>
          <MenuItem name='copy-link-option' mb='1em' className='filter-menu__dropdown-option-display' cursor='default'>
            <Box >
              <Box pt='0.5em' fontWeight='600' fontSize='1em' color='brandDark.500'>Edit options unavailable</Box>
              <Box pb='0.5em' fontWeight='400' fontSize='0.875em'>  <i>{lockerUserName}</i> is currently editing the Room and it's been locked temporarily </Box>
            </Box>
          </MenuItem>
          <MenuDivider />
          {renderReadingModeOption()}
        </MenuList>
      )
    } else {
      return (
        <MenuList px='0.5em' fontSize='0.875em'>
          {dsrId && <MenuItem name='copy-link-option' className='filter-menu__dropdown-option-display' onClick={() => redirectToNewPage(`/edit/${dsrId}`)}  >Edit Room</MenuItem>}
          <MenuItem name='copy-link-option' className='filter-menu__dropdown-option-display' onClick={() => handleUnpublishRoom()}  >Unpublish Room</MenuItem>
          <MenuDivider />
          {renderReadingModeOption()}
          {renderRoomTourOption()}
        </MenuList>
      )
    }
  }

  function renderNonAdminOptions() {

    return (
      <MenuList px='0.5em' fontSize='0.875em'>
        {renderReadingModeOption()}
      </MenuList>
    )

  }

  function renderArchivedDsrOptions() {
    return (
       <MenuList px='0.5em' fontSize='0.875em'>
        <MenuItem name='copy-link-option' className='filter-menu__dropdown-option-display' onClick={() => setIsReadingMode(typeof isReadingMode === "boolean" ? !isReadingMode : true)}  >Reading Mode <span><Box fontSize='0.7em' fontWeight='600' color={isReadingMode ? 'brand.500' : 'gray.500'} ml='0.5em'>{isReadingMode ? "ON" : "OFF"}</Box></span></MenuItem>
        <MenuItem name='copy-link-option' className='filter-menu__dropdown-option-display' onClick={() => openLaunchdeckModal('revert-dsr-to-draft')}  >Unarchive Room</MenuItem>
      </MenuList>
    )
  }


  if (isArchivedDsr) {
    if (!isDsrAdmin) {
      return null
    } else {
      return (
        <Menu isLazy placement="bottom-end" bg='gray.500'>
        <MenuButton
          as={IconButton}
          aria-label='Options'
          icon={<IoChevronDownOutline />}
          size='2em'
          p='0.5em'
          rounded='50%'
        />
        {renderArchivedDsrOptions()}
      </Menu>
      )
    }
  }
  return (
    <>

      <Menu isLazy placement="bottom-end" bg='gray.500'>
        <MenuButton
          as={IconButton}
          aria-label='Options'
          icon={<IoChevronDownOutline />}
          size='2em'
          p='0.5em'
          rounded='50%'
        />
        {isDsrAdmin ? renderAdminOptions() : renderNonAdminOptions()}
      </Menu>

    </>
  );

}